import { render, staticRenderFns } from "./EaseOutBorderIcon.vue?vue&type=template&id=11865134&"
import script from "./EaseOutBorderIcon.vue?vue&type=script&lang=js&"
export * from "./EaseOutBorderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports